import { render, staticRenderFns } from "./ship_vias.vue?vue&type=template&id=066f53cf&"
import script from "./ship_vias.vue?vue&type=script&lang=js&"
export * from "./ship_vias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports